module.exports = __webpack_public_path__ + "static/media/coming_soon.1c56d4f2.png";